import {
    CHANGE_FORM_STATUS,
    CLIENT_FORM_REVIEW,
    CREATE_FORM,
    DELETE_FORM,
    EDIT_FORM,
    GET_CLIENT_FILED_FORM,
    GET_CLIENT_INVITE_FORM,
    GET_FORM_BY_ID,
    GET_FORM_SETTINGS,
    GET_FORMS,
    GET_FORMS_DEFAULT,
    REQUEST_INVITE_FORM,
    RESEND_INVITE_FORM,
    RESET_FORM_BY_ID,
    RESET_FORMS,
    RESET_FORMS_DEFAULT,
    SAVE_INVITE_FORM,
} from './form.type';

/** Forms */
export const getForms = (params, load) => {
    return {
        type: GET_FORMS,
        payload: { params, load },
    };
};

export const resetForms = () => {
    return {
        type: RESET_FORMS,
    };
};
// export const getBasicForms = (model, params, load) => {
//     return {
//         type: GET_BASIC_FORMS,
//         payload: { model, params, load },
//     };
// };

export const getFormDefault = (formId, params) => {
    return {
        type: GET_FORMS_DEFAULT,
        payload: { formId, params },
    };
};
export const resetFormDefault = (id) => {
    return {
        type: RESET_FORMS_DEFAULT,
        payload: { id },
    };
};

/**
 * @param load  'noLoad' to suppress the spinner, or the same params object the
 *              caller passed to `getFormDefault` (legacy shape — callers on the
 *              note-creation path pass params here, everything else passes
 *              nothing).
 * @param resourceId  Appointment the template is being instantiated as a note
 *              for. Lets the api resolve the blocks that read the appointment
 *              rather than the form — SESSION_DATA_TABLE rows and auto-filling
 *              SIGNATURE blocks — before the note has ever been saved; ignored
 *              for templates carrying neither.
 */
export const getFormById = (id, load, resourceId) => {
    return {
        type: GET_FORM_BY_ID,
        payload: { id, load, resourceId },
    };
};

export const resetFormById = () => {
    return {
        type: RESET_FORM_BY_ID,
    };
};

export const getFormSettings = (params, load) => {
    return {
        type: GET_FORM_SETTINGS,
        payload: { params, load },
    };
};
export const createForm = (params, load) => {
    return {
        type: CREATE_FORM,
        payload: { params, load },
    };
};
export const editForm = (id, params) => {
    return {
        type: EDIT_FORM,
        payload: { id, params },
    };
};
export const deleteForms = (id) => {
    return {
        type: DELETE_FORM,
        payload: { id },
    };
};
export const changeFormStatus = (id, status) => {
    return {
        type: CHANGE_FORM_STATUS,
        payload: { id, status },
    };
};
export const getClientInviteForm = (token) => {
    return {
        type: GET_CLIENT_INVITE_FORM,
        payload: { token },
    };
};
export const saveInviteForm = (params, registerToken) => {
    return {
        type: SAVE_INVITE_FORM,
        payload: { params, registerToken },
    };
};
export const resendInviteForm = (params) => {
    return {
        type: RESEND_INVITE_FORM,
        payload: { params },
    };
};
export const requestInviteForm = (inviteToken) => {
    return {
        type: REQUEST_INVITE_FORM,
        payload: { inviteToken },
    };
};

export const getClientFiledForm = (clientId) => {
    return {
        type: GET_CLIENT_FILED_FORM,
        payload: { clientId },
    };
};
export const clientFormReview = (clientId, data, status) => {
    return {
        type: CLIENT_FORM_REVIEW,
        payload: { clientId, data, status },
    };
};
